export enum DxObjectsCacheTypes {
  MarkResponseTime = 'dxObjectsCache/MARK_RESPONSE_TIME',
  InvalidateCache = 'dxObjectsCache/INVALIDATE_CACHE',
}

export type DxObjectsCache = {
  /**
   * Indicates whether or not (and when) a change has been made during the app's lifetime.
   *
   * This needs to be used the first time a request is issued (by requestKey).
   * If there are any changes, the cache should be busted with a skipCache value of true.
   */
  lastChange: string | null;
  /**
   * When recent insights change the cache also needs to be busted on the server.
   *
   * Need to maintain a set of recent insights ids (insights are immutable) to check this.
   *
   * This is more of an internal implementation detail of the reducer, the selector
   * can simply look at the lastChange date.
   */
  recentInsightIds: Set<string>;
  /**
   * Per request type timestamps to be used for cache invalidation.
   *
   * If the request timestamp is prior to the lastChange time, the next request
   * should be issued with a skipCache value of true.
   */
  requests: { [requestKey: string]: string };
};
